import { render, staticRenderFns } from "./apartment-search-form.vue?vue&type=template&id=b12930cc&scoped=true&"
import script from "./apartment-search-form.ts?vue&type=script&lang=ts&"
export * from "./apartment-search-form.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-search-form.scss?vue&type=style&index=0&id=b12930cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12930cc",
  null
  
)

export default component.exports